import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { LAYOUT_DESCRIPTION_MAX_LENGTH } from 'const/limits'
import {
  ControlLabel
} from 'react-bootstrap'
import {
  ListItem
} from 'components/List'
import EditableModal from 'components/EditableModal'
import {
  ViewBody
} from 'components/Sidebar'
import classes from './LayoutDescription.module.scss'

export class LayoutDescription extends React.Component {
  static propTypes = {
    layoutId: PropTypes.number.isRequired,
    description: PropTypes.string,

    permission: PropTypes.object.isRequired,

    requestChangeLayoutDescription: PropTypes.func.isRequired,

    intl: PropTypes.object.isRequired,
  }

  state = {
    isEditing: false
  }

  componentDidUpdate = () => {
    const { permission } = this.props
    const { isEditing } = this.state

    if (
      !permission.owner &&
      isEditing
    ) {
      this.stopEditing()
    }
  }

  handleIsEditingChange = (isEditing) => {
    this.setState({
      isEditing
    })
  }

  handleEditableValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}

    if (name && name.length > LAYOUT_DESCRIPTION_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'DESK_DESCRIPTION_TOO_LONG' }, { limit: LAYOUT_DESCRIPTION_MAX_LENGTH })
    }

    return errors
  }

  handleEditableSubmit = ({ name: newDescription }) => {
    const { layoutId, description, requestChangeLayoutDescription } = this.props

    if (newDescription !== description) {
      requestChangeLayoutDescription({
        id: layoutId,
        description: newDescription
      })
    }

    this.stopEditing()
  }

  stopEditing = () => {
    this.setState({
      isEditing: false
    })
  }

  renderDescription = () => {
    const {
      description
    } = this.props

    return (
      <ListItem>
        {description ? (
          <span
            className={classes.description}
          >
            {description}
          </span>
        ) : (
          <span
            className={classes.notSet}
          >
            <FormattedMessage id='BOARD_INFO_DESCRIPTION_EMPTY' />
          </span>
        )}
      </ListItem>
    )
  }

  render () {
    const {
      permission,

      description
    } = this.props
    const {
      isEditing
    } = this.state

    return (
      <div>
        <ViewBody>
          <ControlLabel><FormattedMessage id='DESK_DESCRIPTION' /></ControlLabel>
        </ViewBody>
        {permission.owner ? (
          <EditableModal
            textarea
            initialValues={{ name: description }}
            isEditing={isEditing}
            onIsEditingChange={this.handleIsEditingChange}
            validate={this.handleEditableValidate}
            onSubmit={this.handleEditableSubmit}
          >
            {this.renderDescription()}
          </EditableModal>
        ) : (
          this.renderDescription()
        )}
      </div>
    )
  }
}

export default injectIntl(LayoutDescription)
